import Axios from "axios";
import React, { useEffect, useState } from "react";
import SpeechRecognition, {
    useSpeechRecognition,
} from "react-speech-recognition";

const Dictaphone = ({ sendDataToParent }) => {
    let api = process.env.REACT_APP_API_URL || "http://localhost:4000";

    console.log(api);

    let [oldListen, setOldListen] = useState(false);

    const {
        transcript,
        listening,
        resetTranscript,
        browserSupportsSpeechRecognition,
    } = useSpeechRecognition();

    useEffect(() => {
        if (!listening) {
            if (oldListen) {
                SpeechRecognition.stopListening();
                const sendData = async () => {
                    let data = JSON.stringify(transcript);
                    const response = await Axios.post(
                        api + "/sendtranscript",
                        { data },
                        {
                            headers: {
                                "Content-Type": "application/json",
                                "Access-Control-Allow-Origin": "*",
                            },
                        }
                    );
                    sendDataToParent(response.data);
                };
                sendData();
            }
        }

        setOldListen(listening);
    });

    function buttonPressed() {
        resetTranscript();
        SpeechRecognition.startListening();
    }

    if (!browserSupportsSpeechRecognition) {
        return <span>Browser doesn't support speech recognition.</span>;
    }

    return (
        <div className="w-full flex justify-center items-center flex-col p-20">
            <button
                onClick={buttonPressed}
                className={`absolute top-3/4 h-20 w-20 bg-red-500 rounded-full text-white font-bold text-2xl flex justify-center items-center ${
                    listening ? "animate-pulse" : ""
                }`}
            >
                <img
                    className="h-12 w-12"
                    src="/icons8-microphone-90.png"
                    alt="microphone"
                />
            </button>
            <p className=" font-bold text-8xl">{transcript}</p>
        </div>
    );
};

export default Dictaphone;
